import {
  RESET_PASSWORD_SENT_OTP,
  FORGOT_PASSWORD_CHECK_OTP,
  CHANGED_PASSWORD,
  VERIFY_EMAIL,
} from "./types";
import axios from "axios";
import { toast } from "react-toastify";
const PROXY = process.env.REACT_APP_URL + "api/";

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const sendEmail = (userObj) => async (dispatch) => {
  // try {
  const res = await axios.post(
    `${PROXY}user/web/reset-password/send-email`,
    userObj
  );
 
  dispatch({
    type: RESET_PASSWORD_SENT_OTP,
    // payload: userObj,
  });
  // toast.success(res.data.message);
  return res;
  // } 
  // catch (error) {
  //   toast.error(error.response.data.message);
  //   return error;
  // }
};

export const verifyEmailOtp = (userObj) => async (dispatch) => {
  // try {
  const res = await axios.post(`${PROXY}user/web/verify/email`, userObj);
  dispatch({
    type: FORGOT_PASSWORD_CHECK_OTP,
    payload: userObj,
  });
  // toast.success(res.data.message);
  return res;
  // } 
  // catch (error) {
  //   // toast.error(error.response.data.message);
  //   return error;
  // }
};

export const verifyEmail = (userObj) => async (dispatch) => {
  try {
  const res = await axios.post(`${PROXY}user/web/verify-email/send-email`, userObj);
  dispatch({
    type: VERIFY_EMAIL,
    payload: userObj,
  });
  // toast.success(res.data.message);
  return res;
  } 
  catch (error) {
    toast.error(error.response.data.message);
    return error;
  }
};
export const changedPassword = (userObj) => async (dispatch) => {
  // try {
  const res = await axios.post(`${PROXY}user/web/reset-password`, userObj);
  dispatch({
    type: CHANGED_PASSWORD,
  });
  // toast.success(res.data.message);
  return res;
  // } 
  // catch (error) {
  //   // toast.error(error.response.data.message);
  //   return error;
  // }
};
